export default __webpack_public_path__ + "static/media/abc.be743191.png";